import { render, staticRenderFns } from "./distributorCard.vue?vue&type=template&id=74a871fe&"
import script from "./distributorCard.vue?vue&type=script&lang=js&"
export * from "./distributorCard.vue?vue&type=script&lang=js&"
import style0 from "./distributorCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports